const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * 60;

const format = (time: number, showMs?: boolean): string => {
  const hours = Math.floor(time / SECONDS_IN_HOUR);
  const minutes = Math.floor((time - hours * SECONDS_IN_HOUR) / SECONDS_IN_MINUTE);
  const seconds = Math.floor(time - hours * SECONDS_IN_HOUR - minutes * SECONDS_IN_MINUTE);
  const milliseconds = Math.floor((time - hours * SECONDS_IN_HOUR - minutes * SECONDS_IN_MINUTE - seconds) * 1000);

  const formattedMilliseconds = ("00" + milliseconds).slice(-3);
  const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;

  const formattedSecondsAndMs = showMs ? `${formattedSeconds}.${formattedMilliseconds}` : formattedSeconds;

  if (hours) {
    return `${hours}:${formattedMinutes}:${formattedSecondsAndMs}`;
  }
  if (minutes) {
    return `${minutes}:${formattedSecondsAndMs}`;
  }
  return `0:${formattedSecondsAndMs}`;
};

export const TimeFormatter = {
  format,
};
